import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.RequestModule.BulkCreationPopupContent.AdditionalOptions', {
    additionalOptionsTitle: 'Additional options',
    editButtonTitle: 'Edit',
    useLinesMergeCheckboxTitle: "Don't extract line items",
    useLinesMergeCheckboxDescription:
        'ApprovalMax Capture will consolidate all {templateName} lines into a single total line.',
});
